import { AxiosAuth } from '../AxiosInstance';

const apiSolicitacaoSuporte = {
    send: async (form) => {
        const URL = `/api/suporte/solicitacao`;
        return await AxiosAuth.post(URL, form,  {
            headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((res) => res)
        .catch(error => {
            console.error('Erro ao buscar os dados:', error);
            throw error;

        })
    },
    
}

export default apiSolicitacaoSuporte;

